import styled from "styled-components";

const Heading = styled.div`
  font-size: 1.8em;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 640px) {
    font-size: 1.2em;
  }
`;

const SubHeading = styled.div`
  font-size: 0.9em;
  @media (max-width: 640px) {
    font-size: 0.6em;
  }
`;

const Classification_Logo = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-end",
        fontFamily: "poppins",
      }}
    >
      <Heading>
        <strong>Te Mana</strong>
        <strong>Whakaatu</strong>
      </Heading>
      <SubHeading>CLASSIFICATION OFFICE</SubHeading>
    </div>
  );
};

export default Classification_Logo;
